import React from 'react'
import { useSelector } from 'react-redux'

import '../styles/footer.scss'
import {profileIDSelector} from "../reducers/profile";

function Footer() {
  const profileUUID = useSelector(profileIDSelector)
  return (
    <div className="account-footer">
      <p>
        У&nbsp;вас появились вопросы или что-то пошло не&nbsp;так?
        <br />
        Напишите нам{' '}
        <nobr>
          на&nbsp;<a href="mailto:radio@arzamas.academy">radio@arzamas.academy</a>
        </nobr>
        , мы&nbsp;поможем разобраться!
        {!!profileUUID ? <br /> : null}
        {!!profileUUID ? `В письме укажите, пожалуйста, идентификатор вашего аккаунта: ${profileUUID}` : null}
      </p>
    </div>
  )
}

export default React.memo(Footer)
